import React from 'react';
import AbstractComponent from '../../AbstractComponent';
import InputSelect from '../../layout/input/InputSelect';

import ModalidadePagamentoService from '../../../service/ModalidadePagamentoService';

class InputSelectModalidadePagamento extends AbstractComponent {

    constructor(props) {
        super(props);  
        
        this.state = {
            listas: [{modalidade_pagamento: {}, valor: 0, texto: 'Selecione'}],

            preload: true,

            erro: {
                message: '',
                code: 0
            }
        }        
    }    

    onChangeSelect(input) {
        let modalidade_pagamento = {};
        let lista = this.state.listas;        

        for(var i = 0; i < lista.length; i++) {                        
            if(parseInt(lista[i].valor, 10) === parseInt(input.target.value, 10)) 
                modalidade_pagamento = lista[i].modalidade_pagamento;                            
        }

        if (this.props.onChange !== undefined) 
            this.props.onChange(input, modalidade_pagamento);        
    }
    
    componentDidMount() {         
        const lista = [{valor: 0, texto: 'Carregando, aguarde...'}];

        this.setState({listas: lista}); 

        ModalidadePagamentoService.listarModalidadeParceladas().then(resposta => {
            const lista = [{valor: 0, texto: 'Selecione'}];

            resposta.data.map(item => {
                lista.push({modalidade_pagamento: item,
                            valor: item.id, 
                            texto: item.descricao, 
                            selected: (parseInt(item.id, 10) === parseInt(this.props.editarId, 10))
                })
                
                return item;
            });

            this.setState({listas: lista, preload: false}); 
        }).catch(error => {                        
            this.setState({
                erro: this.trataErro(error),
                preload: false
            });
        });        
    }            

    render() {
        return (                
            <InputSelect 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg} 
                classNameInput={this.props.classNameInput}                        
                nome={this.props.nome}                             
                id={this.props.nome} 
                options={this.state.listas}                            
                value={this.props.value}  
                erro={this.props.erro}   
                disabled={this.props.disabled}                        
                onChange={e => this.onChangeSelect(e)}
            >                            
                Modalidade de Pagamento
            </InputSelect>                        
        );
    }
}

export default InputSelectModalidadePagamento;